@for (toast of toastService.toasts; track toast) {
  <ngb-toast
    [header]="toast.header ?? ''" 
    [autohide]="true" 
    [delay]="toast.delay || 5000"
    (hidden)="toastService.remove(toast)"
    [class]="toast.classname"
  >{{ toast.body }}</ngb-toast>
}